// @flow
import * as React from "react"
import { DesktopFilterControlsWrap, ControlButton } from "./styled"

type Props = {|
  apply: Function,
  clear: Function,
  hasValue: boolean,
  closeOnChange?: boolean,
|}

const DesktopFilterControls = ({ clear, apply, hasValue, closeOnChange }: Props) => (
  <DesktopFilterControlsWrap>
    <ControlButton primary onClick={clear} disabled={!hasValue}>
      Clear
    </ControlButton>
    { !closeOnChange &&
      <ControlButton primary onClick={apply}>
        Apply
      </ControlButton>
    }
  </DesktopFilterControlsWrap>
)

export default DesktopFilterControls



// WEBPACK FOOTER //
// ./src/searchFilters/Shared/DesktopFilter/DesktopFilterControls/index.js